import { NgModule } from "@angular/core";
import { TranslateModule } from "@ngx-translate/core";
import { CommonModule } from "@angular/common";
import { IonicModule } from "ionic-angular";
import { JobStatusItemComponent } from "./job-status-item.component";

@NgModule({
    imports: [
        CommonModule,
        IonicModule,
        TranslateModule.forChild()
    ],
    declarations: [
        JobStatusItemComponent
    ],
    exports: [
        JobStatusItemComponent
    ]
})
export class JobStatusItemModule {

}



// WEBPACK FOOTER //
// ./src/vas/modules-shared/job-status-item/job-status-item.module.ts